// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../assets/arrow.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".anKTpCtex{-webkit-text-size-adjust:100%;margin-top:32px;padding:20px}@media (min-width: 768px){.anKTpCtex{width:600px}}._54Zy85Eox{position:-webkit-sticky;position:sticky;top:0px;padding:16px 0px}._4WKEzok7x{border-top:1px solid rgba(0,0,0,0.08);color:rgba(0,0,0,0.9)}._6nTCCfflx{padding:16px 32px 16px 0px}._6nTCCfflx[aria-expanded=\"true\"]>span:after{transform:rotateZ(180deg)}._1WPbozvlx{position:relative;display:flex;padding:0px 20px 0px 0px}._1WPbozvlx:after{content:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");position:absolute;right:0px;display:block;transition:transform 300ms}._1P4TnyfBx{overflow:hidden;transition:max-height 400ms linear;height:auto;max-height:400px}._1P4TnyfBx[aria-hidden=\"true\"]{max-height:0px}._1P4TnyfBx ._7eWHAeJ1x{margin-top:16px;margin-bottom:32px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"help": "anKTpCtex",
	"title": "_54Zy85Eox",
	"accordion-item": "_4WKEzok7x",
	"accordionItem": "_4WKEzok7x",
	"accordion-button": "_6nTCCfflx",
	"accordionButton": "_6nTCCfflx",
	"accordion-title": "_1WPbozvlx",
	"accordionTitle": "_1WPbozvlx",
	"accordion-content": "_1P4TnyfBx",
	"accordionContent": "_1P4TnyfBx",
	"accordion-content-text": "_7eWHAeJ1x",
	"accordionContentText": "_7eWHAeJ1x"
};
module.exports = exports;
